/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type MilestoneType from '@linc-technologies/linced-common/enums/milestone-type';
import type ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import type MilestoneSet from '@linc-technologies/linced-common/models/milestones/milestone-set';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: milestones.Milestone.
export default class Milestone extends Model {
  declare [Type]: 'milestones/milestone';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @alias('school.id')
  declare school_id: string | null | undefined;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('number', { defaultValue: 0 })
  declare type: EnumValue<typeof MilestoneType> | 0;

  @attr('number', { defaultValue: 0 })
  declare duration: number;

  @attr('number', { defaultValue: 0 })
  declare yearLevel: number;

  @attr('number', { defaultValue: 0 })
  declare month: number;

  @attr('number', { defaultValue: 0 })
  declare day: number;

  @attr('boolean', { defaultValue: false })
  declare isInterim: boolean;

  @attr('number', { defaultValue: 0 })
  declare progressionType: EnumValue<typeof ProgressionType> | 0;

  @belongsTo('milestones/milestone-set', { async: true, inverse: 'milestones' })
  declare setId: AsyncBelongsTo<MilestoneSet>;

  @alias('setId')
  declare milestoneSet: AsyncBelongsTo<MilestoneSet>;

  @alias('milestoneSet.id')
  declare set_id: string | null | undefined;

  @attr('string', { defaultValue: '' })
  declare templateId: string;
}
